export var CalendarViews;
(function (CalendarViews) {
    CalendarViews["WEEK"] = "week";
    CalendarViews["MONTH"] = "month";
})(CalendarViews || (CalendarViews = {}));
